export default __webpack_public_path__ + "static/media/coin_1gms.0abade03.jpg";